import { CaloriesUpdateRequest } from "@/clients/models/CaloriesUpdateRequest";
import { NutritionalRequirementsService } from "@/clients/services/NutritionalRequirementsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useUpdateCalories = () => {
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isError, error } = useMutation({
    mutationKey: [QueryKeys.NUTRITIONAL_REQUIREMENT, "update-calories"],
    mutationFn: async (caloriesUpdate: CaloriesUpdateRequest) => {
      const user = guardGetUserFromLocalStorage();
      return NutritionalRequirementsService.updateCaloriesApiV1NutritionalRequirementsCaloriesPut(
        user.id,
        caloriesUpdate,
      );
    },
    onSuccess: () => {
      // Invalidate calories query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT, "calories"],
      });
      // Also invalidate the general nutritional requirement query
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.NUTRITIONAL_REQUIREMENT],
      });
    },
  });

  return {
    updateCalories: mutate,
    updateCaloriesAsync: mutateAsync,
    isUpdating: isPending,
    isError,
    error,
  };
};
